import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getAllCateringClaims(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`catering-option-claims?${parameters}`);
  return data;
}

export async function getCateringClaims(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${registrationId}/catering-claims?${parameters}`
  );
  return data;
}

export async function getCateringClaim(registrationId, id) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/catering-claims/${id}`
  );
  return data;
}

export async function createCateringClaim(registrationId, values) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/catering-option-claims`,
    values
  );
  return data;
}

export async function updateCateringClaim(registrationId, id, values) {
  const { data } = await axios.patch(
    `/registrations/${registrationId}/catering-claims/${id}`,
    values
  );
  return data;
}

export async function deleteCateringClaim(registrationId, id) {
  const { data } = await axios.delete(
    `/registrations/${registrationId}/catering-option-claims/${id}`
  );
  return data;
}
